module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/add-to-unscopables.js
// module id = 164
// module chunks = 0 1